import React from "react";
import { Spinner } from "react-bootstrap";

const Loading = () => {
  return (
    <div className="py-5 text-center">
      <Spinner animation="border" role="status" variant="info">
        <span className="sr-only">Cargando...</span>
      </Spinner>
    </div>
  );
};

export default Loading;
